import { window } from "global";
// Apollo
import fetch from "node-fetch";
import { setContext } from "@apollo/link-context";
import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { getGraphQlUrl } from "lib/regionalApiUrlHelper";

export function initApolloClient(authToken, apolloState = undefined, ssrMode = false) {
  const httpLink = createHttpLink({ uri: getGraphQlUrl(), fetch });
  const authLink = setContext((_, { headers }) => {
    const customHeaders =
      process.env.BUILD_TYPE === "dev"
        ? {}
        : {
            "x-is-ssr": ssrMode,
          };

    return {
      headers: {
        ...headers,
        ...customHeaders,
        authorization: authToken ? `Bearer ${authToken}` : "",
      },
    };
  });

  let cache = new InMemoryCache();
  if (apolloState && Object.keys(apolloState).length > 0) {
    cache = new InMemoryCache().restore(apolloState);
  }

  const apolloClient = new ApolloClient({
    ssrMode: ssrMode,
    link: authLink.concat(httpLink),
    cache,
  });

  return apolloClient;
}
